import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Comment } from '../../domain/comment';
import { CommentType } from '../../domain/enums/comment-type';

@Component({
   selector: 'app-task-comments',
   templateUrl: './task-comments.component.html',
   styleUrls: ['./task-comments.component.scss']
})
export class TaskCommentsComponent {
   @Input()
   comments: Array<Comment>;

   @Output()
   hideComments = new EventEmitter();
   protected readonly CommentType = CommentType;

   constructor() {
      this.comments = [];
   }
   getCommentClass(comment: Comment): string {
      let result: string;
      switch (comment.type) {
         case CommentType.Ai:
            result = 'ai-comment';
            break;

         case CommentType.User:
         case CommentType.System:
         default:
            result = 'user-comment';
            break;
      }
      return result + ' chat-message-content';
   }
}
